import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/season/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/season/';

class SeasonService {

  getAllSimilaritySeasons() {
    return axios.get(API_URL  + 'similarity');
  }

  getAllPlayersFromSeason(leagueId, year) {
    return axios.get(API_URL  + 'players/league/' + leagueId + '/year/' + year);
  }

  getSeasonsByLeaguesAndYears(leagueIds, years) {
    return axios.get(API_URL  + 'leagues/' + leagueIds + '/years/' + years);
  }

  getTableBySeason(leagueId,year) {
    return axios.get(`${API_URL}table/${leagueId}/${year}`);
  }

  getStatsTableBySeason(leagueIds,years,total) {
    return axios.get(`${API_URL}stats/table/${leagueIds}/${years}/${total}`);
  }

  getSeasonAvgStats(seasonId){
    return axios.get(`${API_URL}${seasonId}/average-stats`);
  }

  getSeasonAvgPDStats(seasonId){
    return axios.get(`${API_URL}${seasonId}/average-pd-stats`);
  }

  getSeasonTeamStatsPD(seasonId, teamId){
    return axios.get(`${API_URL}${seasonId}/team/${teamId}/stats-pd`);
  }

  getSeasonsByTeam(teamId){
    return axios.get(`${API_URL}team/${teamId}`);
  }

  getRadarSeasonsOfTeam(teamId){
    return axios.get(`${API_URL}radar/team/${teamId}`);
  }

  getTeamsOfSeasons(seasonIds) {
    return axios.get(`${API_URL}teams/${seasonIds}`);
  }

  getTeamsBySeasonIds(seasonIds) {
    return axios.get(`${API_URL}${seasonIds}/s/teams`);
  }

  getSeasonSubstitutions(seasonId) {
    return axios.get(`${API_URL}${seasonId}/substitutions`);
  }

  getGamesByLeagueAndYear(leagueId,year) {
    return axios.get(`${API_URL}${leagueId}/${year}/games`);
  }

  getCompetitions(seasonId) {
    return axios.get(`${API_URL}${seasonId}/competitions`);
  }

  getLeagueTable(seasonId) {
    return axios.get(`${API_URL}${seasonId}/league-table`);
  }

  getLeagueTableByYear(leagueId,year) {
    return axios.get(`${API_URL}${leagueId}/${year}/league-table`);
  }

  getSeasonsByLeagues(leagueIds, maxYearsVisible) {
    return axios.get(API_URL  + 'leagues/' + leagueIds + '/years-visible/' + maxYearsVisible);
  }

  getAvailablePhysicalSeasons(clientId) {
    return axios.get(API_URL  + 'available-physical-seasons/' + clientId);
  }

  postSeason(season) {
    return axios.post(`${API_URL}`,season);
  }

}

export default new SeasonService();



// WEBPACK FOOTER //
// ./src/services/season.service.js